import * as React from "react";
import styled from "../../../styled/index";
import { CS } from "../../../styles/index";
const Icon = styled("div") `
  ${CS.flex.center};
  border-radius: 50%;
  // @ts-ignore
  background: ${({ background, theme }) => background || theme.colors.primary};
  color: white;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  font-size: ${({ size, iconSizeModifier }) => size - (iconSizeModifier || 18)}px;
`;
export const IconCircle = (props) => (React.createElement(Icon, Object.assign({}, props),
    !!props.icon && props.icon,
    !props.icon && props.children));
//# sourceMappingURL=index2.js.map